import { render, staticRenderFns } from "./TrafficList.vue?vue&type=template&id=5bf198aa&scoped=true"
import script from "./TrafficList.vue?vue&type=script&lang=js"
export * from "./TrafficList.vue?vue&type=script&lang=js"
import style0 from "./TrafficList.vue?vue&type=style&index=0&id=5bf198aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf198aa",
  null
  
)

export default component.exports